import { apiUrl } from "../../config/base.js";
import axios from 'axios';

export default {

	checkEmailExists(email) {
		return axios.post(apiUrl + '/users/check-email-exists', { email: email });
	},

	register(user, account_number) {
		return axios.post(apiUrl + '/register', { user: user, account_number: account_number });
	},

	login(data, accountNumber) {
		return axios.post(apiUrl + '/login', { email: data.email, password: data.password, accountNumber: accountNumber });
	},

	resendVerificationEmail(account_number) {
		return axios.get(apiUrl + '/users/send-verification-email?account_number=' + account_number);
	},

	verifyEmail(email, email_verification_code, account_number) {
		return axios.post(apiUrl + '/users/verify-email', { email: email, email_verification_code: email_verification_code, account_number: account_number });
	},

	// verifyPhone(phone_verification_code, account_number) {
	// 	return axios.post(apiUrl + '/users/verify-phone', { phone_verification_code: phone_verification_code, account_number: account_number });
	// },

	resendVerificationPhone(account_number) {
		return axios.get(apiUrl + '/users/send-verification-phone?account_number=' + account_number);
	},

	updatePhone(phone) {
		return axios.post(apiUrl + '/users/update-phone', { phone: phone });
	},
	wrongEmail(account_number) {
		return axios.post(apiUrl + '/users/wrong-email', { account_number: account_number });
	}
}

